export const loadImage = (src) => new Promise((res, rej) => {
  const i = new Image();
  i.onload = () => res(i);
  i.onerror = rej;
  i.src = src;
});

// Rotates the full image, then crops `area` (in rotated-image pixels) to a white-backed square JPEG.
export async function cropSquare(src, area = null, rotation = 0, size = 1200) {
  const img = await loadImage(src);
  const rad = (rotation * Math.PI) / 180;
  const sin = Math.abs(Math.sin(rad));
  const cos = Math.abs(Math.cos(rad));
  const bw = img.width * cos + img.height * sin;
  const bh = img.width * sin + img.height * cos;
  const rc = document.createElement("canvas");
  rc.width = bw;
  rc.height = bh;
  const rctx = rc.getContext("2d");
  rctx.translate(bw / 2, bh / 2);
  rctx.rotate(rad);
  rctx.drawImage(img, -img.width / 2, -img.height / 2);
  const s = Math.min(bw, bh);
  const a = area || { x: (bw - s) / 2, y: (bh - s) / 2, width: s, height: s };
  const out = document.createElement("canvas");
  out.width = size;
  out.height = size;
  const ctx = out.getContext("2d");
  ctx.fillStyle = "#ffffff";
  ctx.fillRect(0, 0, size, size);
  ctx.drawImage(rc, a.x, a.y, a.width, a.height, 0, 0, size, size);
  return new Promise((res) => out.toBlob((b) => res(b), "image/jpeg", 0.92));
}
